import buildOneDimensionMetricTotals from './buildOneDimensionMetricTotals';
import buildTwoDimensionDateTotals from './buildTwoDimensionDateTotals';
import buildTwoDimensionDayOfWeekTotals from './buildTwoDimensionDayOfWeekTotals';

const buildMatrixTotals = ({
  chartDef,
  reverseAxes,
  isTwoDimensional,
  rangeBuckets,
  responses,
  groupByField,
  usedMetrics,
  unitsLocale,
  rowData,
  formatMetric,
}: {
  chartDef: V5ChartDefinition;
  reverseAxes: boolean;
  isTwoDimensional: boolean;
  rangeBuckets: string[];
  responses: MetricsResponse[];
  groupByField: string;
  usedMetrics: Metrics.Metric[];
  unitsLocale: string;
  rowData: MatrixRowData[];
  formatMetric: (args: {
    metricId: string;
    value: string | number | null | undefined;
  }) => string;
}): MatrixRowData[] => {
  // Skip totals for reversed axes (can be added in future enhancement)
  if (reverseAxes) {
    return [];
  }

  if (isTwoDimensional) {
    const metricId = chartDef.series[0].metricId;
    const metric = usedMetrics.find((m) => m.id === metricId);
    if (!metric) {
      throw new Error(`Metric ${metricId} not found`);
    }
    const s = chartDef.series.find((s) => s.metricId === metric.id);

    if (
      chartDef.dimensionB &&
      chartDef.dimensionB.field === 'date' &&
      rowData.length > 0
    ) {
      return buildTwoDimensionDateTotals({
        chartDef,
        rangeBuckets,
        groupedHistogram: responses[0],
        histogram: responses[1],
        metricId,
        metric,
        unitsLocale,
        s,
        groupByField,
        formatMetric,
      });
    } else if (chartDef.dimensionB && chartDef.dimensionB.isGroupByDayOfWeek) {
      return buildTwoDimensionDayOfWeekTotals({
        groupedHistogram: responses[0],
        histogram: responses[1],
        metric,
        metricId,
        groupByField,
        formatMetric,
      });
    } else {
      const formatted = {};
      // @ts-ignore
      formatted[groupByField] = 'Total';
      return [formatted];
    }
  } else {
    return buildOneDimensionMetricTotals({
      chartDef,
      unitsLocale,
      groupByField,
      usedMetrics,
      currentTotal: responses[1],
      previousTotal: responses[3] || [],
      formatMetric,
    });
  }
};

export default buildMatrixTotals;
